/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener("theme:variant:change", function (event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      if (typeof handleVariantChange == "function") {
        handleVariantChange(variant);
      }
      // ... update some element on the page
    }
  });

  document.addEventListener("theme:cart:change", function (event) {
    var cart = event.detail.cart;
    if (cart) {
      if (typeof updateCartCount == "function") {
        updateCartCount(cart);
      }
      if (typeof handleCartRecommendation == "function") {
        handleCartRecommendation(cart);
      }
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener("theme:cart:init", (event) => {
    var cart = event.detail.cart;
    if (cart) {
      if (typeof updateCartCount == "function") {
        updateCartCount(cart);
      }
      if (typeof handleCartRecommendation == "function") {
        handleCartRecommendation(cart);
      }
    }
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.

  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow

  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

(function checkSortBy() {
  let sortBy = window.location.href.includes('sort_by=') ? window.location.href.split('sort_by=')[1].split('&')[0] : '';

  let sortButtonText = document.querySelector('[data-sort-button-text]');

  if (sortButtonText && sortBy) {
    sortButtonText.innerHTML = sortBy;
  }
})();

function createSlidesFromJson(swiperContainer, slidesData) {
  try {
    // Parse the JSON data from the div content
    const jsonText = slidesData.textContent.trim();
    if (!jsonText) return;

    // Wrap in array brackets if not already an array
    const jsonArray = jsonText.startsWith('[') ? jsonText : `[${jsonText}]`;
    const images = JSON.parse(jsonArray);

    const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
    if (!swiperWrapper) return;

    // Create slides for each image
    images.forEach((image, index) => {
      const slide = document.createElement('div');
      slide.className = 'new_card_product_media swiper-slide inside-swiper-images';

      const img = document.createElement('img');
      // Generate srcset from the base image URL
      const baseUrl = image.src.split('?')[0]; // Remove query parameters
      const queryParams = image.src.split('?')[1]; // Get query parameters
      const srcset = `${baseUrl}?${queryParams}&width=100 100w, ${baseUrl}?${queryParams}&width=352 352w`;

      img.srcset = srcset;
      img.src = image.src;
      img.alt = image.alt;
      img.sizes = image.sizes;
      img.loading = 'lazy';
      img.fetchpriority = 'low';
      img.className = 'motion-reduce media_product';
      img.setAttribute('width', '100%');
      img.setAttribute('height', '100%');

      slide.appendChild(img);
      swiperWrapper.appendChild(slide);
    });

    // Remove the JSON data div after creating slides
    slidesData.remove();
  } catch (error) {
    console.error('Error parsing slides JSON:', error);
  }
}

function swiperCards(whoCalledThis, swiperContainers = document.querySelectorAll(".collection-cardSwiper")) {
  swiperContainers.forEach((swiperContainer) => {
    let slidesData = swiperContainer.querySelector('[data-id="image-slides-in-json"]');
    let swiper;

    if (screen.width > 479) {
      // Desktop: Create slides on mouseenter
      swiperContainer.addEventListener("mouseenter", () => {
        if (!swiper) {
          // Create slides from JSON data
          if (slidesData) {
            createSlidesFromJson(swiperContainer, slidesData);
            slidesData = null; // Clear reference after use
          }
          const swiperPrev = swiperContainer.querySelector(".swiper-button-prev");
          const swiperNext = swiperContainer.querySelector(".swiper-button-next");

          // Stop event propagation for inner swiper buttons
          if (swiperPrev) {
            swiperPrev.addEventListener("click", (e) => e.stopPropagation());
          }
          if (swiperNext) {
            swiperNext.addEventListener("click", (e) => e.stopPropagation());
          }

          swiper = new Swiper(swiperContainer, {
            navigation: {
              nextEl: swiperNext,
              prevEl: swiperPrev,
            },
            allowTouchMove: false
          });
          swiper.slideTo(1);
          swiperNext.style.display = "block";
          swiperPrev.style.display = "block";
        }
      });

      swiperContainer.addEventListener("mouseleave", () => {
        if (swiper) {
          swiper.destroy(true, true);
          swiper = null;
        }
        const swiperPrev = swiperContainer.querySelector(".swiper-button-prev");
        const swiperNext = swiperContainer.querySelector(".swiper-button-next");
        swiperNext.style.display = "none";
        swiperPrev.style.display = "none";
      });
    } else {
      // Mobile: Create slides immediately and initialize swiper
      if (slidesData) {
        createSlidesFromJson(swiperContainer, slidesData);
      }

      swiper = new Swiper(swiperContainer, {
        pagination: {
          el: swiperContainer.querySelector(".swiper-pagination"),
          clickable: true
        },
        allowTouchMove: true
      });
    }
  });
}

function showColorVariant(event) {
  // Cache the clicked color swatch and container elements
  const clickedColorSwatch = event.target.closest("div[data-color-swatch-id]");
  const productCardContainer = event.target.closest("product-grid-item");

  // Get the swipers and swatch ID from the clicked element
  const swipers = productCardContainer.querySelectorAll(".collection-cardSwiper");
  const clickedSwatchId = clickedColorSwatch.getAttribute("data-color-swatch-id");
  const clickedSwatchHandle = clickedColorSwatch.getAttribute("data-color-swatch-handle");
  const productViewButtonAttribute = `productQuickViewButton(${clickedSwatchId}, '${clickedSwatchHandle}')`;

  const productLink = productCardContainer.querySelector("a[data-grid-link]");

  swipers.forEach((swiperSlide) => {
    const swiperProductId = swiperSlide.getAttribute("data-card-product-id");
    const swiperProductTitle = swiperSlide.getAttribute("data-product-title");

    if (swiperProductId === clickedSwatchId) {
      // Show the matched swiper
      swiperSlide.classList.remove("swiperHidden");
      productCardContainer.querySelector(".product__grid__title").textContent = swiperProductTitle;

      // Remove 'colorSwatchBorder' from all swatches inside the same container
      productCardContainer.querySelectorAll("div[data-color-swatch-id]").forEach((colorSwatch) => {
        colorSwatch.classList.remove("colorSwatchBorder");
      });

      // Add 'colorSwatchBorder' to the clicked swatch
      clickedColorSwatch.classList.add("colorSwatchBorder");

      if (productCardContainer.querySelector("div[data-quickview-holder]")) {
        productCardContainer.querySelector("div[data-quickview-holder]").setAttribute("data-quickview-holder", clickedSwatchId);
      }
      if (productCardContainer.querySelector("div[data-product-handle]")) {
        productCardContainer.querySelector("div[data-product-handle]").setAttribute("data-product-handle", clickedSwatchHandle);
      }
      if (productLink) {
        productLink.setAttribute("href", `/products/${clickedSwatchHandle}`);
        productLink.setAttribute("data-product-url", clickedSwatchHandle);
        productLink.setAttribute("aria-label", `${swiperProductTitle}`);
      }
    } else {
      // Hide non-matching swipers
      swiperSlide.classList.add("swiperHidden");
    }
  });
}

let drawerToggle = document.querySelectorAll('[data-drawer-toggle="hamburger"]');
if (drawerToggle.length > 0) {
  drawerToggle.forEach((toggleButton) => {
    toggleButton.addEventListener('click', (event) => {
      let smileUIContainer = document.querySelector('#smile-ui-lite-container');
      if (smileUIContainer) {
        if (smileUIContainer.style.display !== 'none') {
          smileUIContainer.style.display = 'none';
        } else {
          smileUIContainer.style.display = null;
        }
      }
      let chatContainer = document.querySelector('#shopify-chat');
      if (chatContainer) {
        if (chatContainer.style.display !== 'none') {
          chatContainer.style.display = 'none';
        } else {
          chatContainer.style.display = null;
        }
      }
    });
  });
}

if(window.innerWidth < 767) {
  const intervalIDSHopifyChat = setInterval(() => {
    // Select the element to which you want to attach the shadow root
    const hostElement = document.querySelector('#shopify-chat');
    if(hostElement) {
      if(hostElement.querySelector('inbox-online-store-chat')) {
        hostElement.querySelector('inbox-online-store-chat').style.transformOrigin = 'center';
        hostElement.querySelector('inbox-online-store-chat').style.transform = 'scale(0.7)';
      }
      clearInterval(intervalIDSHopifyChat);
    }
  }, 100);
}

document.addEventListener(
  "DOMContentLoaded",
  () => {
    swiperCards("DOMContentLoaded");
  },
  { once: true }
);
